import React, { FC, useEffect, useState } from "react";
import NavBurgerButton from "../../../components/common/Buttons/NavBurgerButton";
import NavProfileButton from "../../../components/common/Buttons/NavProfileButton";
import ThemeButton from "../../../components/common/Buttons/ThemeButton";
import HelpButton from "../../../components/common/Buttons/HelpButton";
import FeedbackButton from "../../../components/common/Buttons/FeedbackButton";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import useSelector from "../../../hooks/useSelector";
import LogoHC from "../../../assets/img/logo-top-trim-icon-reposition.png";
import LogoHCDark from "../../../assets/img/logo-h-w-new.png";
import { Link } from "react-router-dom";
import { INavItem } from "../index";
import NewNavigationTab from "./NewNavigationTab";
import * as AuthenticationHelper from "../../../helpers/authentication";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { AppSettings } from "../../../helpers/AppSettings";

import "./NewNavigation.scss";

const NewNavigation: FC = () => {
    const permissions = useSelector(state => state.user.userSummary?.permissions ?? []);
    const drawerItems = useSelector((state) => state.navigation.drawerItems);
    const user = useSelector((state) => state.user.data);
    const light = useSelector((state) => state.theme.light);

    const [navigationTabs, setNavigationTabs] = useState<INavItem[]>([]);

    const isAuthed =
        !!user.roles?.["Global"].includes("BctStaff") ||
        !!user.roles?.["Global"].includes("Admin");

    useEffect(() => {
        let tabs = [
            {
                icon: FontAwesomeIcons.Duotone.HOME,
                title: "Dashboard",
                url: "/dashboard",
            }
        ];

        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.TRIAL,
                title: "Trials",
                url: "/trials",
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.INSTITUTION,
                title: "Institutions",
                url: "/institutions",
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.GROUP,
                title: "Groups",
                url: "/groups",
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.FLASKVIAL,
                title: "Labs",
                url: "/labs",
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.CLIPBOARD,
                title: "Projects",
                url: "/projects",
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.USER,
                title: "Personnel",
                url: "/personnel",
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.COMMITTEE,
                title: "Committee",
                url: "/committees",
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.SettingsView, null, null)) {
            tabs.push({
                icon: FontAwesomeIcons.Duotone.SETTINGS,
                title: "Settings",
                url: "/settings",
            });
        }

        tabs.push({
            icon: FontAwesomeIcons.Duotone.SEARCH,
            title: "Search",
            url: "/search",
        });

        setNavigationTabs(tabs);

    }, [permissions, setNavigationTabs]);

    // Method to render the navigation tabs
    const renderNavigationTabs = () => {
        return navigationTabs?.map((tab, index) => (
            <NewNavigationTab key={index} navItem={tab} />
        ));
    };

    return (
        <header className="navigation">
            <div className="navigation-container">
                {/**  Navigation menu */}
                <div
                    className="navigation-burger-button"
                    style={{
                        visibility:
                            drawerItems?.length > 0 ? "visible" : "hidden",
                    }}
                >
                    <NavBurgerButton />
                </div>

                {/**  Logo */}
                <img className="header-img" src={light ? LogoHC : LogoHCDark} />

                {/** Title */}
                <Link className="header-link" to="/" style={{ textDecoration: "none" }}>
                    <h6>Trial Management</h6>
                </Link>

                {/** Right-Side **/}
                <div className="navigation-right-side">
                    {/** Nav Items */}
                    <div className="navigation-tab-container">
                        {isAuthed && renderNavigationTabs()}
                    </div>
                    {/** Feedback */}
                    {
                        isAuthed && 
                        AppSettings.sentry.dsn && 
                        AppSettings.sentry.enableReportABug && 
                        <FeedbackButton />}

                    {/** Theme */}
                    <ThemeButton />

                    {/** Help */}
                    {isAuthed && <HelpButton />}

                    {/** Profile */}
                    <NavProfileButton />
                </div>
            </div>
        </header>
    );
};

export default NewNavigation;
